define('home/templates/forumCard',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a href=\"/home/channel/"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.slug : stack1), depth0))
    + "/\"\nclass=\"avatar\"\ndata-link-name=\"forum_avatar\"\ndata-forum-pk=\""
    + alias2(alias1((depth0 != null ? depth0.pk : depth0), depth0))
    + "\">\n"
    + ((stack1 = container.invokePartial(partials.channelAvatarWithDefault,depth0,{"name":"channelAvatarWithDefault","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</a>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.forumAvatarLink,depth0,{"name":"forumAvatarLink","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    return "<span class=\"label--default -inline\">Creator</span>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.sessionUserIsModerator : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    return "<span class=\"label--default -inline\">Moderator</span>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(container.lambda((depth0 != null ? depth0.channelDescription : depth0), depth0))
    + "\n";
},"12":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<a href=\""
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "\"\ndata-link-out=\""
    + alias2(alias1((depth0 != null ? depth0.signedUrl : depth0), depth0))
    + "\"\nclass=\"link-gray\"\ndata-link-name=\"forum_description\"\ndata-forum-pk=\""
    + alias2(alias1((depth0 != null ? depth0.pk : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "</a>\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.if_all.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.sessionUserIsModerator : depth0),(depth0 != null ? depth0.channel : depth0),{"name":"if_all","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<button class=\"button button-outline -border-muted text-error button-small spacing-right-small\"\ntitle=\""
    + alias2(helpers.gettext.call(alias1,"Remove Moderator",{"name":"gettext","hash":{},"data":data}))
    + "\"\ndata-action=\"remove-moderator\">\n<span class=\"icon-tiny icon-cancel spacing-right-small\"></span>"
    + alias2(helpers.gettext.call(alias1,"Resign",{"name":"gettext","hash":{},"data":data}))
    + "\n</button>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"card--user\">\n<div class=\"user-card__block\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.channel : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "<div class=\"forum-info\">\n"
    + ((stack1 = container.invokePartial(partials.channelAwareForumLink,depth0,{"name":"channelAwareForumLink","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.sessionUserIsOwner : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "<p class=\"description truncate-line text-medium\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.channelDescription : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data})) != null ? stack1 : "")
    + "</p>\n</div>\n</div>\n<div class=\"user-card__button btn-follow--mobile\">\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.sessionUserIsOwner : depth0),{"name":"unless","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(partials.genericFollowButton,depth0,{"name":"genericFollowButton","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
